<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-medium"
    title="確認"
  >
    <template v-slot:body="{ cancel, ok }">
      <!-- BODY -->
      <v-card-text class="pa-0">
        <div class="modal-body">
          <v-container>
            <div class="font-weight-bold mb-3">
              こちらの内容でCPA 5G SAを契約します。よろしいですか？
            </div>
            <h3>CPA 5G SA約款確認</h3>
            <v-row class="my-2">
              <v-col>
                <label class="ml-3"
                  >リモートアクセスサービス契約約款に同意しました。</label
                >
              </v-col>
            </v-row>
            <div>
              <h3>CPA 5G SA契約</h3>
              <div class="mt-2">
                <v-row>
                  <v-col>
                    <app-label-group
                      label="契約"
                      :value="
                        $filter.enumTo(
                          cpa5gContractData.contractType,
                          'cpaContractType'
                        )
                      "
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <app-label-group
                      label="VPN/VNコード"
                      :value="
                        cpa5gContractData.vpnVnCode.startsWith('B')
                          ? cpa5gContractData.vpnVnCode
                          : cpa5gContractData.vpnVnCode +
                            '(' +
                            displayVnName +
                            ')'
                      "
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <app-label-group
                      label="認証タイプ"
                      :value="
                        $filter.enumTo(
                          cpa5gContractData.authenticationType,
                          'cpaAuthenticationType'
                        )
                      "
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <app-label-group
                      label="ドメイン"
                      :value="cpa5gContractData.domain"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <app-label-group
                      label="冗長"
                      :value="
                        $filter.enumTo(
                          cpa5gContractData.redundancy,
                          'cpaRedundancy'
                        )
                      "
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <app-label-group
                      label="品目"
                      :value="
                        $filter.enumTo(
                          cpa5gContractData.bandwidthType,
                          'cpaBandwidthType'
                        )
                      "
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <app-label-group
                      label="アドレスアサイン方式"
                      :value="
                        $filter.enumTo(
                          cpa5gContractData.addressAssignmentMethod,
                          'cpaAddressAssignMethod'
                        )
                      "
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <app-label-group
                      label="IPアドレス"
                      :value="
                        $filter.enumTo(
                          cpa5gContractData.ipAddressType,
                          'cpaIpAddressType'
                        )
                      "
                    />
                  </v-col>
                </v-row>
              </div>
            </div>
          </v-container>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <!-- FOOTER -->
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn @click="ok" variant="flat" color="primary">はい </v-btn>
            <v-btn @click="cancel" variant="outlined" color="primary"
              >いいえ
            </v-btn>
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import type { CreateCpaContract } from "@/apis/Cpa5gSaApi";

export default defineComponent({
  name: "SaContractConfirm",
  components: {},
  props: {
    cpa5gContractData: {
      type: Object as PropType<CreateCpaContract>,
      required: true,
    },
    displayVnName: {
      type: [String, null] as PropType<string | null>,
      required: true,
    },
  },
});
</script>
